<dx-data-grid class="bg-transparent"
    [(dataSource)]="dataSource"
    [columnAutoWidth]="true"
    [showBorders]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [scrolling]="{ mode: 'virtual', showScrollbar: 'always', rowRenderingMode: 'virtual', columnRenderingMode: 'virtual', renderAsync: true }"

    [noDataText]="(!$clientGroupId() ? 'ADMIN.ACCOUNTS.FIELD.ClientIds_Placeholder_NoGroup' : 'ADMIN.ACCOUNTS.FIELD.ClientIds_Placeholder') | translate"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserted)="onRowInserted($event)"
    (onRowRemoved)="onRowRemoved($event)"
    >

    <dxo-editing mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="$allowAdding()"
        [useIcons]="true"
        [(changes)]="changes"
        [form]="{
            showValidationSummary: true,
            validationGroup: $validationGroupName()
        }"
        newRowPosition="last"
        refreshMode="repaint"/>

    <dxo-toolbar>
        <dxi-item location="before">
            <div class="dx-field-label w-100">
                {{ 'ADMIN.ACCOUNTS.FIELD.Clients' | translate }}
                @if($isRequired()){
                    <span class="dx-field-item-required-mark" aria-hidden="true">&nbsp;*</span>
                }
            </div>
        </dxi-item>
        <dxi-item location="after" name="addRowButton"></dxi-item>
        <dxi-item location="after" name="saveButton"></dxi-item>
        <dxi-item location="after" name="revertButton"></dxi-item>
    </dxo-toolbar>

   <!-- COLUMNS-->
    <dxi-column
        dataField="UserId" caption="User ID"
        dataType="string"
        [allowEditing]="false"
        [visible]="false"></dxi-column>
    <dxi-column
        dataField="ClientGroupId" caption="Client Group"
        dataType="number"
        [allowEditing]="false"
        [visible]="false"
        [lookup]="{ dataSource: dataSourceClientGroups, valueExpr: 'Id', displayExpr: 'Name' }"></dxi-column>
    <dxi-column
        dataField="ClientId" caption="Client"
        dataType="number"
        [showEditorAlways]="true"
        [validationRules]="[{type: 'required'}]"
        [lookup]="{ dataSource: dataSourceClients, valueExpr: 'Id', displayExpr: 'Name' }"></dxi-column>
    <dxi-column
        dataField="AllowHealth" caption="Health"
        dataType="boolean"
        [showEditorAlways]="true"
        [validationRules]="validationRulesTrueFalse"
        [lookup]="lookupTrueFalse"
        [width]="90"
        cssClass="p-0 text-center"></dxi-column>
    <dxi-column
        dataField="AllowAutoFleet" caption="Auto Fleet"
        dataType="boolean"
        [showEditorAlways]="true"
        [validationRules]="validationRulesTrueFalse"
        [lookup]="lookupTrueFalse"
        [width]="90"
        cssClass="p-0 text-center"></dxi-column>
    <dxi-column type="buttons" [width]="60" cssClass="p-0" [fixed]="true"></dxi-column>

</dx-data-grid>
